if (typeof DiscountNotice !== "function") {


  var discountStorage = (key, value) => {
    var lsSupport = false;

    // Check for native support
    if (localStorage) {
      lsSupport = true;
    }

    // If value is detected, set new or modify store
    if (typeof value !== "undefined" && value !== null) {
      // Convert object values to JSON
      if (typeof value === "object") {
        value = JSON.stringify(value);
      }
      // Set the store
      if (lsSupport) {
        // Native support
        localStorage.setItem(key, value);
      } else {
        // Use Cookie
        createCookie(key, value, 30);
      }
    }

    // No value supplied, return value
    if (typeof value === "undefined") {
      // Get value
      if (lsSupport) {
        // Native support
        data = localStorage.getItem(key);
      } else {
        // Use cookie
        data = readCookie(key);
      }

      // Try to parse JSON...
      try {
        data = JSON.parse(data);
      } catch (e) {
        data = data;
      }

      return data;
    }

    // Null specified, remove store
    if (value === null) {
      if (lsSupport) {
        // Native support
        localStorage.removeItem(key);
      } else {
        // Use cookie
        createCookie(key, "", -1);
      }
    }

    /**
     * Creates new cookie or removes cookie with negative expiration
     * @param  key       The key or identifier for the store
     * @param  value     Contents of the store
     * @param  exp       Expiration - creation defaults to 30 days
     */

    function createCookie(key, value, exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
      document.cookie = key + "=" + value + expires + "; path=/";
    }

    /**
     * Returns contents of cookie
     * @param  key       The key or identifier for the store
     */

    function readCookie(key) {
      var nameEQ = key + "=";
      var ca = document.cookie.split(";");
      for (var i = 0, max = ca.length; i < max; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  };
  
  class DiscountNotice extends HTMLElement {
    constructor() {
      super();
      const url_string = window.location.href;
      const url = new URL(url_string);
      const discount_notice = url.searchParams.get("discount_note");
      const discount_code = url.searchParams.get("discount_code");
      const showStorewide = this.getAttribute('data-show-storewide') == 'true';

      if (discount_notice || showStorewide) {
        const text = this.querySelector(".ds-discount-notice__text");
        let templateText;

        let cc = this.getCookie("discount_code");
        if (!cc && discount_code) {
          cc = discount_code
        }

        if (cc) {
          discountStorage('discount_code_referrer', cc)
        }

        if (showStorewide) {
          const store = discountStorage('discount_code_referrer')
          if (store && !cc) {
            cc = store
          }
        }
        if (cc && text) {
          let coupon_code = cc.toString();
          coupon_code = coupon_code.split('&')[0];
      
          templateText = text.innerHTML;
          text.innerHTML = templateText.replace('[code]', coupon_code.toUpperCase());
          this.style.display = "block";
        }
      } else {
        this.style.display = "none";
      }




      if (window.discountCodeCalculation) {
        const dcr = getCookie("discount_code");
        if (dcr && window.productData) {
          var coupon_code = dcr.toString();
          var checkoutUrl = `https://secretbrands-checkout-api-2.digitalsprung.de/checkout/${coupon_code.toLowerCase()}/${window.productData.productId}/${window.productData.variantId}?shop=${Shopify.shop}&price=${window.productData.price}`

          fetch(checkoutUrl)
          .then(response => response.json())
          .then(data => {
            if (data?.status == 'valid') {
              window.dispatchEvent( new CustomEvent('product-discount', {'detail': data}) );
            }
          });
        }
      }
    }
    getCookie(name) {
      return document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=')
        return parts[0] === name ? decodeURIComponent(parts[1]) : r
      }, '') 
    }
  }

  if (typeof customElements.get("discount-notice") == "undefined") {
    customElements.define("discount-notice", DiscountNotice);
  }
}
